import * as styles from './Header.module.css';
import IconCircle from '../iconCircle/IconCircle.jsx';

export default ({ o }) => {
  return (
    <div class={`${styles.header} border-bottom`}>
      <button
        id={styles.overlay}
        onclick={o.closeEmployeeMenu}
        onkeydown={(e) => e.key === 'Enter' && o.closeEmployeeMenu(e)}
        class="hidden button-reset"
      ></button>
      <div id={styles.headerTop} class="border-bottom">
        <div class="content-container">
          <div class={styles.left}>
            <a class={styles.logo} href="#welcome/main" alt="Strona główna">
              <img src="images/pko-bez-napisu.jpg" alt="Logo PKO Platin light" />
              <div class={styles.text}>
                <div class={styles.upper}>Platin</div>
                <div class={styles.lower}>LIGHT</div>
              </div>
            </a>
          </div>
          <div class={styles.right}>
            <button
              id={styles.user}
              onclick={o.toggleEmployeeMenu}
              onkeydown={(e) => e.key === 'Enter' && o.toggleEmployeeMenu(e)}
              class="withArrow button-reset"
            >
              <div class={styles.tooltipMenu}>
                <div class={styles.tooltipHeader}>Zmień jednostkę</div>
                <div class={styles.tooltipBody} style="height: 300px; overflow: auto;">
                  <ul onclick={o.changeUserUnit} onkeydown={(e) => e.key === 'Enter' && o.changeUserUnit(e)}> {/* NOSONAR: Świadoma delegacja eventów na ul w celu optymalizacji */}
                    {o.userData.availableUnits.map((unit) => {
                      const selected = unit.statisticalUnitNumber === o.userData.selectedUnit.statisticalUnitNumber;
                      return (
                        <li class={selected ? styles.selectedUnit : ''} vx-unit-number={unit.statisticalUnitNumber}>
                          {unit.name}, <strong>{unit.statisticalUnitNumber}</strong>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>

              <IconCircle>{o.userData.firstName[0] + o.userData.surname[0]}</IconCircle>
              <div class={styles.name}>
                {o.userData.firstName} {o.userData.surname}
                <br />
                <div class={styles.unit}>
                  {o.userData.selectedUnit && (
                    <>
                      {o.userData.selectedUnit.shortName},{' '}
                      <strong>{o.userData.selectedUnit.statisticalUnitNumber}</strong>
                    </>
                  )}
                  <br />
                  Role: {o.userData.selectedUnit.roles.join(', ')}
                </div>
              </div>
            </button>
            <button
              class={`${styles.logout} link-button`}
              onClick={o.onLogout}
              onkeydown={(e) => e.key === 'Enter' && o.onLogout(e)}
            >
              <img src="images/logout.svg" alt="Wyloguj" /> Wyloguj
            </button>
          </div>
        </div>
      </div>
      <div id={styles.menuContainer} class="content-container">
        <div id="menu"></div>
      </div>
    </div>
  );
};
